export default "__VITE_ASSET__FTNXQxFr__"